import { useRouter } from 'next/router'
import { useState } from 'react'

import { SignInContent } from '@/components/authenticationModal/signInContent'
import { ModalProps } from '@/components/Modal/Modal'
import { LoginRequest } from '@/shared/api/models'
import { usePixieWorldAuthContext } from '@/shared/auth/pixieWorldAuthContext'

export type SignInFormProps = Omit<ModalProps, 'children'> & {
  //  
}

export const SignInForm: React.FC<SignInFormProps> = () => {
  const [loginLoading, setLoginLoading] = useState(false)
  const [loginError, setLoginError] = useState('')
  const router = useRouter()

  const { signIn } = usePixieWorldAuthContext()

  const onSignIn = async (variables: LoginRequest) => {
    setLoginLoading(true)

    try {
      const response = await signIn(variables)

      if (response?.access_token) {
        router.push('/')
      }
    } catch (error) {
      setLoginError('Login Failed')
    } finally {
      setLoginLoading(false)
    }
  }
  

  return (
    <SignInContent
      errorMessage={loginError}
      loading={loginLoading}
      onSignIn={onSignIn}
    />
  )
}
